<div class="main">
  <i class="pi pi-search"></i>
  <input type="text" placeholder="Search column" />
</div>
